import React from 'react';
import styles from './ServicePeriodInfo.scss';
import classNames from 'classnames';

const MONTHLY = 'monthly';
const YEARLY = 'yearly';

function ServicePeriodInfo({ service, handleClick, subscribtionPackage }) {
  const { periodUnit, price, discount } = service;
  const periodUnitText = periodUnit === 'Months' ? MONTHLY : YEARLY;

  const hasDiscount = Object.keys(discount).length > 0 && discount.price;
  const hasServiceCTASpacing = discount && discount.discountPercentage && discount.price;

  return (
    <section
      className={classNames(styles.root, {
                [styles.servicePeriodInfoDiscountWrapper]: hasServiceCTASpacing,
            })}
        >
      {hasDiscount && discount.discountPercentage && (
        <div className={styles.servicePeriodInfoDiscount}>
          <p className={styles.servicePeriodInfoDiscountText}>
            {discount.discountPercentage}
          </p>
        </div>
            )}
      <button
        className={classNames(styles.servicePeriodInfoButton, {
                    [styles.servicePeriodInfoButtonMonthly]: periodUnitText === MONTHLY,
                    [styles.servicePeriodInfoButtonDiscount]: hasDiscount,
                })}
        data-button-color={periodUnitText === MONTHLY ? subscribtionPackage : ''}
        onClick={() => handleClick(hasDiscount && discount.campaignUrl ? discount.campaignUrl : null)}
            >
        <p
          className={classNames(styles.periodText, {
                        [styles.periodTextDiscounted]: hasDiscount,
                    })}
                >
          {periodUnitText}
        </p>
        <div
          className={classNames(styles.servicePeriodInfoWrapper, {
                        [styles.servicePeriodInfoWrapperFlexed]: hasDiscount,
                    })}
                >
          <p
            className={classNames(styles.discountedPrice, {
                            [styles.discountedPriceVisible]: hasDiscount,
                        })}
                    >
                        £{Number(discount.price).toFixed(2)}
          </p>
          <span
            className={classNames(styles.servicePeriodInfoPrice, {
                            [styles.servicePeriodInfoPriceDiscounted]: hasDiscount,
                        })}
                    >
                        £{Number(price).toFixed(2)}
          </span>
        </div>
      </button>
    </section>
  );
}

export default ServicePeriodInfo;
